/**
 * Copyright (C) 2020Ø Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function TerminalListConnectivityHeaderIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fontSize={props.fontSize}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>573A52A5-5DA2-41F9-8F41-3A9D69DD939B</title>
        <defs>
          <rect id="path-1" x="0" y="0" width="16" height="4" />
          <rect id="path-3" x="0" y="0" width="16" height="4" />
          <rect id="path-5" x="0" y="0" width="16" height="4" />
        </defs>
        <g id="Terminal_list" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Terminal_list_sorted_by_ID" transform="translate(-93.000000, -248.000000)">
            <g id="Group-3" transform="translate(93.000000, 248.000000)">
              <g id="Oval">
                <mask id="mask-2" fill="white">
                  <use href="#path-1" />
                </mask>
                <g id="Mask" />
                <circle fill="#5EA215" mask="url(#mask-2)" cx="8" cy="8" r="8" />
              </g>
              <g id="Oval" transform="translate(0.000000, 6.000000)">
                <mask id="mask-4" fill="white">
                  <use href="#path-3" />
                </mask>
                <g id="Mask" />
                <circle fill="#C5F042" mask="url(#mask-4)" cx="8" cy="2" r="8" />
              </g>
              <g id="Oval" transform="translate(0.000000, 12.000000)">
                <mask id="mask-6" fill="white">
                  <use href="#path-5" />
                </mask>
                <g id="Mask" />
                <circle fill="#C3CDD5" mask="url(#mask-6)" cx="8" cy="-4" r="8" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
